var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconMemberPaysLarge = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h30v30H0z"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(3.333 5)",
    fill: "#7A8E96",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.729 0c2.76 0 4.996 2.194 4.996 4.9 0 2.705-2.237 4.9-4.996 4.9a5.071 5.071 0 0 1-1.82-.336c1.861-.714 3.178-2.488 3.178-4.564 0-2.077-1.317-3.851-3.177-4.565A5.055 5.055 0 0 1 14.73 0z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 9.271,
    cy: 4.9,
    rx: 4.997,
    ry: 4.9
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.281 11.2c3.163 0 5.719 2.507 5.719 5.623v3.483a.702.702 0 0 1-.708.694h-3.638c.39 0 .708-.312.708-.694v-3.483c0-3.116-2.556-5.622-5.719-5.622z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.824 11.2h-7.09C2.57 11.2 0 13.723 0 16.824v3.483c0 .382.318.694.708.694h17.127c.39 0 .708-.312.708-.694v-3.483c0-3.116-2.557-5.622-5.72-5.622z"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconMemberPaysLarge);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/icon-member-pays-large.1dbbc94f803ce9995bce679a38d63aef.svg";